import React, {createContext, useReducer} from 'react'
import {AslDeviceOverviewReducer} from "../reducer/AslDeviceOverviewReducer";

export const AslDeviceOverviewContext = createContext();

const AslDeviceOverviewContextProvider = (props) => {
    const data = {
        sortPref: {column: "name", direction: "ascending"},
        aslDeviceInformation: {},
        macAddressArray: [],
        loadingOverview: true
    }
    const [viewModel, dispatch] = useReducer(AslDeviceOverviewReducer, data)
    return (
        <AslDeviceOverviewContext.Provider value={{viewModel, dispatch}}>
            {props.children}
        </AslDeviceOverviewContext.Provider>
    )
}

export default AslDeviceOverviewContextProvider



// WEBPACK FOOTER //
// ./src/components/devicemanagement/asldevice/context/AslDeviceOverviewContext.js